import { useEffect } from 'react';
import { FEATURE_FLAGS } from '~/constants';
import { useShareableFlags } from '~/hooks/useShareableFlags';

import { useFlagStore } from './store';

interface SharedFeatureFlagsProps {
  shareToken: string | undefined;
}

export const SharedFeatureFlags = ({ shareToken }: SharedFeatureFlagsProps) => {
  const { updateFlags, setStatus } = useFlagStore();
  const {
    data: flags,
    isSuccess,
    isError,
    isLoading,
  } = useShareableFlags(shareToken);

  useEffect(() => {
    if (isLoading) return;

    if (isError || !flags) {
      updateFlags([]);
      setStatus('error');
      return;
    }

    if (isSuccess) {
      const validFlags = flags.filter((flag): flag is FEATURE_FLAGS =>
        Object.values(FEATURE_FLAGS).includes(flag as FEATURE_FLAGS),
      );
      updateFlags(validFlags);
      setStatus('success');
    }
  }, [flags, isSuccess, isError, isLoading, updateFlags, setStatus]);

  return null;
};
